import { useState } from 'react';
import { Button } from '../../ui/kit/components/primitives';
import { Icon } from '../../ui/kit/components/icons';
import { guildApi } from '../../lib/guild';
import type { AuthUser } from '../../lib/types';
import './guild.css';

export function guestPathAllowed(pathname: string, projectIds: string[]): boolean {
  if (pathname === '/guild' || pathname.startsWith('/guild/')) return true;
  const match = /^\/projects\/([^/]+)(\/|$)/.exec(pathname);
  return Boolean(match && projectIds.includes(decodeURIComponent(match[1])));
}

export function useGuestExit(user: AuthUser | null | undefined) {
  const [busy, setBusy] = useState(false);
  const home = user?.studios?.[0] || null;
  const leave = async () => {
    if (!home) return;
    setBusy(true);
    try {
      await guildApi.switchStudio(home.id);
      window.location.assign('/guild?tab=contracts');
    } finally { setBusy(false); }
  };
  return { home, busy, leave };
}

export default function GuestBanner({ user }: { user: AuthUser }) {
  const { home, busy, leave } = useGuestExit(user);
  return <div className="guild-guest-banner" role="status">
    <Icon name="users" size={14} aria-hidden="true" />
    <span>You are working in <strong>{user.org?.name || 'the client’s studio'}</strong> as a Guild artist. You can open only the hired production.</span>
    {home ? <Button size="sm" variant="ghost" loading={busy} onClick={() => void leave()}>Back to {home.name}</Button> : null}
  </div>;
}
